import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=643a27c4&scoped=true"
import script from "./monitor.vue?vue&type=script&lang=js"
export * from "./monitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a27c4",
  null
  
)

export default component.exports